import axios from "axios";

const baseURL =
  process.env.VUE_APP_API_BASE_URL || "https://backend.europelotto.work/api";

const api = axios.create({
  baseURL,
  timeout: 30000,
  withCredentials: false,
  headers: {
    Accept: "application/json",
  },
});

export default api;
